import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import type { TrackRepository } from '../../services/shared.repositories';
import { TrackApi } from '../../apis/track-api';
import type { TrackData } from '../../types';

@injectable()
export class TrackRepositoryImpl implements TrackRepository {
    constructor(
        @inject(TrackApi) private trackApi: TrackApi
    ) {
    }

    track(data: TrackData) {
        return this.trackApi.track(data);
    }
}
